const worldKinectConfig = {
  title: 'World Kinect Technology Radar',
  subheading: '',
  heading: {
    publications: 'World Kinect Technology Radar | Publications',
    emerging: 'World Kinect Technology Radar | Emerging Blips',
    movers: 'World Kinect Technology Radar | Recent Movers',
    core: 'World Kinect Technology Radar | Core Stack',
    off_radar: 'World Kinect Technology Radar | Off Radar',
  },
}

module.exports = {
  worldKinectConfig,
}
